import React from "react";
import styles from "./index.module.scss";
import { Button, Divider, Icon, message } from "antd";
import Space from "components/Space";
import { Link, useRouteMatch } from "react-router-dom";
import classNames from "classnames";
import UserAvatar from "../../../Components/UserAvatar";
import {
    AskListItem,
    QueryType,
    shieldAnsweringQuestion
} from "../../../../../service/discuss";
import moment from "moment";
import DeleteConfirm from "../../../../../components/DeleteConfirm";
import useRequestFn from "../../../../../utils/useRequestFn";
import { errorMessage } from "../../../../../service/service";

interface ListItemProps {
    data: AskListItem;
    reload: () => void;
    query: QueryType;
}

export default function ListItem({ data, reload, query }: ListItemProps) {
    const { path } = useRouteMatch();

    const [passQues] = useRequestFn(shieldAnsweringQuestion);

    async function pass() {
        try {
            await passQues({
                batchNo: data.batchNo,
                courseNo: data.courseNo,
                courseSeq: data.courseSeq,
                uuid: data.uuid
            });
            reload();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <div className={classNames(styles.root)}>
            <div className={styles.front}>
                <UserAvatar userNo={data.askerNo} userName={data.askerName} />
            </div>
            <div className={styles.body}>
                <h1 className={styles.course}>
                    {data.courseName} {data.courseNo}-{data.courseSeq}
                    {query !== QueryType.Blocked && (
                        <Space
                            className={styles.buttons}
                            split={<Divider type="vertical" />}>
                            <DeleteConfirm
                                title="确定要屏蔽吗？"
                                onSuccess={pass}>
                                <Button type="link">屏蔽</Button>
                            </DeleteConfirm>
                        </Space>
                    )}
                </h1>

                <div className={styles.overs}>
                    <Link
                        className={styles.link}
                        to={`${path}/${data.batchNo}/${data.courseNo}/${data.courseSeq}/${data.uuid}`}
                    />
                    <div className={styles.title}>{data.questionTitle}</div>
                    <div className={styles.hide}>
                        <div
                            className={styles.summary}
                            dangerouslySetInnerHTML={{
                                __html: data.questionContent
                            }}
                        />
                    </div>
                </div>

                <Space className={styles.info} size={5}>
                    <span>{data.askerName}</span>
                    <span>
                        {moment(data.createTime).format("YYYY-MM-DD HH:mm")}
                    </span>
                </Space>
            </div>

            <Space className={styles.tail} direction="vertical">
                <Space className={styles.statics} size={20}>
                    <span>
                        <Icon type="solution" /> {data.statics.partInCount}
                        人参与
                    </span>
                    <span>
                        <Icon type="message" /> {data.statics.replyCount}条发言
                    </span>
                </Space>
            </Space>
        </div>
    );
}
